// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/Store";
import VCharts from 'v-charts'
import '@/utils/tools'
// import FastClick from 'fastclick';
// FastClick.attach(document.body);
import 'v-charts/lib/style.css'
import moment from 'moment'
Vue.prototype.$moment = moment;

Vue.use(VCharts);

Vue.config.productionTip = false;

// 获取系统配置
store.dispatch('getSystemConfig');

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js